import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import { CollapsibleDetails, CollapsibleRow, CollapsibleSummary } from "@shared/table/CollapsibleRow";
import { TableRowCells } from "@shared/table/TableRowCells";
import { Row } from "@tanstack/react-table";

import { useStyles } from "./ReleaseNotesPage.style";
import { ReleasedImage } from "./types";

type Props = {
    row: Row<ReleasedImage>;
};

export const ReleaseNotesRow = ({ row }: Props) => {
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    return (
        <CollapsibleRow>
            <CollapsibleSummary row={row}>
                <TableRowCells row={row} />
            </CollapsibleSummary>
            <CollapsibleDetails>
                {row.original.changes.length > 0 ? (
                    row.original.changes.map((change, index) => (
                        <Typography key={index} className={classes.changeLog}>
                            - {change}
                        </Typography>
                    ))
                ) : (
                    <Typography>{t("pages:releaseNotesPage.noReleasesChanges")}</Typography>
                )}
            </CollapsibleDetails>
        </CollapsibleRow>
    );
};
